import { getProductName } from "./productCore";

export function getExchangeProductId(product) {
    return product?.id;
}

export function getExchangeProductName(product) {
    return getProductName(product);
}

function getProducts(exchangeToData) {
    return exchangeToData?.products;
}

function getInventoryMerchant(variant) {
    return variant?.inventoryMerchant;
}

function hasMerchantInventory(variant) {
    return getInventoryMerchant(variant) > 0;
}

function getOriginalVariant(exchangeToData) {
    return exchangeToData?.originalVariant;
}

export function getOriginalVariantWithMerchantInventory(exchangeToData) {
    const originalVariant = getOriginalVariant(exchangeToData);
    if (hasMerchantInventory(originalVariant)) {
        return originalVariant;
    }
    return null;
}

export function productHasInventory(product) {
    return product?.hasInventory;
}

export function variantHasInventory(variant) {
    return productHasInventory(variant);
}

export function hasAnyVariantWithInventory(exchangeToData) {
    return !!getProducts(exchangeToData)?.find((product) => productHasInventory(product));
}

export function anyExchangeAlternativeExists(exchangeToData) {
    return exchangeToData?.exchangeAlternativeExists;
}

export function getVariantsWithInventory(productExchangeServiceData) {
    return productExchangeServiceData?.data?.complaintOptions?.find((p) => p.isOriginal)?.variants?.filter((v) => v?.inventoryMerchant);
}

export function getExchangeBaseProduct(productExchangeServiceData) {
    return productExchangeServiceData?.data?.complaintOptions?.find((p) => p.isOriginal);
}
